import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import * as MuiIcons from '@mui/icons-material';

interface CategoryIconProps {
  category: string;
  color: string;
  icon?: string;
  isSelected: boolean;
  clickable?: boolean;
}

const CategoryIcon: React.FC<CategoryIconProps> = ({
  category,
  color,
  icon,
  isSelected,
  clickable = true,
}) => {
  const iconStyle = {
    backgroundColor: 'white',
    borderRadius: '50%',
    padding: '2px',
    fontSize: '1.25rem',
    boxShadow: clickable ? '0px 4px 8px rgba(0, 0, 0, 0.6)' : 'none',
    cursor: clickable ? 'pointer' : 'auto',
    color: color,
    border: isSelected ? '2px solid red' : 'none',
  };

  if (icon && icon in MuiIcons) {
    const CustomIcon = MuiIcons[
      icon as keyof typeof MuiIcons
    ] as React.ElementType;
    return <CustomIcon sx={iconStyle} />;
  }

  switch (category) {
    default:
      return <PlaceIcon sx={iconStyle} />;
  }
};

export default CategoryIcon;
